import { httpsCallable } from 'firebase/functions'
import { getFirebaseFunctions } from '../firebaseClient'

export async function callFunction<TRequest, TResponse>(
  name: string,
  data?: TRequest,
  options?: Record<string, unknown>,
): Promise<TResponse> {
  const callable = httpsCallable(getFirebaseFunctions(), name, options)
  const result = await callable(data)
  return result.data as TResponse
}
